import { gql } from 'urql';

// Distinct states / cities / zips among the selected warehouse's locations, for the
// Manage Locations filter dropdowns.
//
// Lives in `pending/` (not `requests/`) because the backend field (sc-67610) is not yet in
// the stage GraphQL schema — so the stage-glob codegen (`./src/graphql/requests/*.ts`) must
// not see this operation. Types are generated from a standalone SDL via
// `npm run generate:customer-location-filters:types`. The operation name carries the
// `routeManagement` product prefix literally so graphql-codegen can resolve it statically.
export const GET_CUSTOMER_LOCATION_FILTER_OPTIONS = gql`
  query routeManagementGetCustomerLocationFilterOptions($warehouseId: ID!) {
    customerLocationFilterOptions(warehouseId: $warehouseId) {
      states
      cities
      zips
    }
  }
`;
